// ─────────────────────────────────────────────────────────────────────────────
// Frostbound Shop — Catálogo de productos
// IDs marcados con /* v */ requieren verificación en la DB:
//   SELECT entry, name, ItemLevel FROM item_template WHERE name LIKE '%X%';
// ─────────────────────────────────────────────────────────────────────────────

export const PROFESSIONS = [
  { id: 164, name: 'Herrería',      icon: 'trade_blacksmithing' },
  { id: 165, name: 'Peletería',     icon: 'trade_leatherworking' },
  { id: 171, name: 'Alquimia',      icon: 'trade_alchemy' },
  { id: 182, name: 'Herboristería', icon: 'trade_herbalism' },
  { id: 186, name: 'Minería',       icon: 'trade_mining' },
  { id: 197, name: 'Costura',       icon: 'trade_tailoring' },
  { id: 202, name: 'Ingeniería',    icon: 'trade_engineering' },
  { id: 333, name: 'Encantamiento', icon: 'trade_engraving' },
  { id: 393, name: 'Desuello',      icon: 'inv_misc_pelt_wolf_01' },
  { id: 755, name: 'Joyería',       icon: 'inv_misc_gem_01' },
  { id: 773, name: 'Inscripción',   icon: 'inv_inscription_tradeskill01' },
];

export const SECONDARY_PROFESSIONS = [
  { id: 185, name: 'Cocina',            icon: 'inv_misc_food_15' },
  { id: 129, name: 'Primeros Auxilios', icon: 'inv_misc_bandage_15' },
  { id: 356, name: 'Pesca',             icon: 'trade_fishing' },
];

// Categoría → subcategorías → sub-subcategorías
export const CATEGORY_TREE = {
  comandante: {
    label: 'EL COMANDANTE',
    subs: [
      { key: 'warband',     label: 'WARBAND' },
      { key: 'servicios',   label: 'SERVICIOS' },
      { key: 'profesiones', label: 'PROFESIONES' },
      { key: 'movilidad',   label: 'MOVILIDAD' },
    ],
  },
  trono_helado: {
    label: 'TRONO HELADO',
    subs: [
      { key: 'monturas',    label: 'MONTURAS' },
      { key: 'mascotas',    label: 'MASCOTAS' },
      { key: 'consumibles', label: 'CONSUMIBLES' },
      { key: 'apariencias', label: 'APARIENCIAS' },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// PRODUCTOS
// category / subcategory / subsubcategory (opcional)
// action_type: 'send_items' | 'levelup' | 'dual_profession' | 'secondary_profession' |
//              'change_name' | 'customize' | 'change_race' | 'change_faction' |
//              'voucher' (suma bonos según `grants`; ver VOUCHER_PRODUCTS en shop_router.py)
// ─────────────────────────────────────────────────────────────────────────────
const P = (obj) => obj; // helper para legibilidad

export const PRODUCTS = [

  // ══════════════════════════════════════════════════════════════════════════
  // EL COMANDANTE
  // ══════════════════════════════════════════════════════════════════════════

  P({
    id: 'pack_alter',
    name: 'Pack Alter',
    subtitle: 'Subida a 80 + Maestría en 2 profesiones + Alijo del Mercenario',
    category: 'comandante', subcategory: 'warband',
    price_crystals: 2700, quality: 'epic',
    icon: 'achievement_guildperk_everybodysfriend', badge: 'AHORRA 800',
    features: [
      'Un bono de cada servicio, para el personaje que elijas',
      'Canjéalos cuando quieras desde cada servicio',
      'Los bonos no caducan',
    ],
    wow_item_ids: [],
    action_type: 'voucher',
    grants: { pase_nivel_80: 1, maestria_profesion: 1, caja_fuerte_mercenario: 1 },
  }),

  P({
    id: 'bono_pase80_x3',
    name: 'Bono Warband: 3 Subidas a 80',
    subtitle: 'Tres alters a nivel máximo, un 20 % más barato',
    category: 'comandante', subcategory: 'warband',
    price_crystals: 3600, quality: 'epic',
    icon: 'achievement_level_80', badge: null,
    features: [
      '3 bonos de Subida a Nivel 80',
      'Canjéalos cuando quieras desde la Subida a 80',
      'Los bonos no caducan',
    ],
    wow_item_ids: [],
    action_type: 'voucher',
    grants: { pase_nivel_80: 3 },
  }),

  P({
    id: 'bono_pase80_x5',
    name: 'Bono Warband: 5 Subidas a 80',
    subtitle: 'Cinco alters a nivel máximo, un 25 % más barato',
    category: 'comandante', subcategory: 'warband',
    price_crystals: 5600, quality: 'legendary',
    icon: 'achievement_level_80', badge: null,
    features: [
      '5 bonos de Subida a Nivel 80',
      'Canjéalos cuando quieras desde la Subida a 80',
      'Los bonos no caducan',
    ],
    wow_item_ids: [],
    action_type: 'voucher',
    grants: { pase_nivel_80: 5 },
  }),

  P({
    id: 'bono_faccion_x3',
    name: 'Bono Warband: 3 Cambios de Facción',
    subtitle: 'Pasa tres personajes al otro bando, un 20 % más barato',
    category: 'comandante', subcategory: 'warband',
    price_crystals: 2880, quality: 'epic',
    icon: 'achievement_bg_winwsg', badge: null,
    features: [
      '3 bonos de Cambio de Facción',
      'Canjéalos cuando quieras desde el Cambio de Facción',
      'Los bonos no caducan',
    ],
    wow_item_ids: [],
    action_type: 'voucher',
    grants: { cambio_faccion: 3 },
  }),

  P({
    id: 'bono_faccion_x5',
    name: 'Bono Warband: 5 Cambios de Facción',
    subtitle: 'Pasa cinco personajes al otro bando, un 25 % más barato',
    category: 'comandante', subcategory: 'warband',
    price_crystals: 4500, quality: 'legendary',
    icon: 'achievement_bg_winwsg', badge: null,
    features: [
      '5 bonos de Cambio de Facción',
      'Canjéalos cuando quieras desde el Cambio de Facción',
      'Los bonos no caducan',
    ],
    wow_item_ids: [],
    action_type: 'voucher',
    grants: { cambio_faccion: 5 },
  }),

  P({
    id: 'pase_nivel_80',
    name: 'Pase Nivel 80',
    subtitle: 'Sube instantáneamente al nivel máximo',
    category: 'comandante', subcategory: 'servicios',
    price_crystals: 1500, quality: 'epic',
    icon: 'achievement_level_80', badge: 'MÁS POPULAR',
    features: ['Sube al instante a nivel 80', 'Habilidades de equitación aprendidas', 'Compatible con bots de Warband'],
    wow_item_ids: [],
    action_type: 'levelup',
  }),

  P({
    id: 'caja_fuerte_mercenario',
    name: 'Alijo del Mercenario',
    subtitle: 'Suministros para empezar fuerte',
    category: 'comandante', subcategory: 'servicios',
    price_crystals: 1000, quality: 'rare',
    icon: 'inv_misc_bag_19', badge: null,
    features: ['2.500 Monedas de Oro', '4 Bolsas de 36 casillas', 'Llega al buzón al momento'],
    wow_item_ids: [23162, 23162, 23162, 23162],
    action_type: 'send_items',
  }),

  P({
    id: 'maestria_profesion',
    name: 'Maestría en 2 Profesiones',
    subtitle: 'Elige tus 2 profesiones al máximo nivel',
    category: 'comandante', subcategory: 'profesiones',
    price_crystals: 1000, quality: 'rare',
    icon: 'trade_blacksmithing', badge: null,
    features: ['2 profesiones distintas al 450', 'Selecciona cuáles quieres', 'Sin repetición de profesión'],
    wow_item_ids: [],
    action_type: 'dual_profession',
  }),

  P({
    id: 'maestria_secundaria',
    name: 'Maestría Secundaria',
    subtitle: 'Una profesión secundaria al máximo nivel',
    category: 'comandante', subcategory: 'profesiones',
    price_crystals: 400, quality: 'rare',
    icon: 'inv_misc_food_15', badge: null,
    features: [
      'Cocina, Primeros Auxilios o Pesca al 450',
      'Recetas de instructor incluidas',
      'Conectado o desconectado: sin esperas',
    ],
    wow_item_ids: [],
    action_type: 'secondary_profession',
  }),

  P({
    id: 'paquete_vuelo',
    name: 'Paquete de Vuelo Ártico',
    subtitle: 'Vuelo 280% + Acceso a Rasganorte + Montura por facción',
    category: 'comandante', subcategory: 'movilidad',
    price_crystals: 800, quality: 'rare',
    icon: 'inv_inscription_talenttome01', badge: null,
    features: [
      'Skill Cold Weather Flying (vuelo en Rasganorte)',
      'Artisan Riding 280% aprendido automáticamente',
      'Montura épica de vuelo según tu facción',
    ],
    wow_item_ids: [],
    action_type: 'send_items',
  }),

  P({
    id: 'cambio_nombre',
    name: 'Cambio de Nombre',
    subtitle: 'Elige un nombre nuevo para tu personaje',
    category: 'comandante', subcategory: 'servicios',
    price_crystals: 400, quality: 'rare',
    icon: 'inv_misc_note_06', badge: null,
    features: [
      'Pantalla de cambio de nombre al entrar',
      'Conserva todo lo demás',
      'Conectado o no: se aplica al volver a entrar',
    ],
    wow_item_ids: [],
    action_type: 'change_name',
  }),

  P({
    id: 'cambio_aspecto',
    name: 'Cambio de Aspecto',
    subtitle: 'Reabre el barbero completo, sin coste de oro',
    category: 'comandante', subcategory: 'servicios',
    price_crystals: 600, quality: 'rare',
    icon: 'inv_misc_head_human_02', badge: null,
    features: [
      'Sexo, cara, pelo, color y accesorios',
      'También permite cambiar el nombre',
      'Conectado o no: se aplica al volver a entrar',
    ],
    wow_item_ids: [],
    action_type: 'customize',
  }),

  P({
    id: 'cambio_raza',
    name: 'Cambio de Raza',
    subtitle: 'Cambia la raza conservando tu facción',
    category: 'comandante', subcategory: 'servicios',
    price_crystals: 800, quality: 'epic',
    icon: 'achievement_character_bloodelf_female', badge: null,
    features: [
      'Selector de raza al entrar al juego',
      'Conserva nivel, equipo y profesiones',
      'Conectado o no: se aplica al volver a entrar',
    ],
    wow_item_ids: [],
    action_type: 'change_race',
  }),

  P({
    id: 'cambio_faccion',
    name: 'Cambio de Facción',
    subtitle: 'Pásate de Alianza a Horda o viceversa',
    category: 'comandante', subcategory: 'servicios',
    price_crystals: 1200, quality: 'epic',
    icon: 'achievement_bg_winwsg', badge: null,
    features: [
      'Reasignación de raza, ciudad y reputaciones',
      'Conserva nivel, equipo y profesiones',
      'Conectado o no: se aplica al volver a entrar',
    ],
    wow_item_ids: [],
    action_type: 'change_faction',
  }),


  // ══════════════════════════════════════════════════════════════════════════
  // TRONO HELADO — MONTURAS
  // ══════════════════════════════════════════════════════════════════════════

  P({
    id: 'invencible',
    name: 'Riendas de Invencible',
    subtitle: 'La montura del Rey Exánime',
    category: 'trono_helado', subcategory: 'monturas',
    price_crystals: 3000, quality: 'legendary',
    icon: 'ability_mount_pegasus', badge: 'EXCLUSIVO',
    features: ['Velocidad de vuelo 310%', 'Montura icónica del Rey Exánime', 'Efecto visual único'],
    wow_item_ids: [50818],
    action_type: 'send_items',
  }),

  P({
    id: 'tigre_espectral',
    name: 'Tigre Espectral Presto',
    subtitle: 'Montura TCG extremadamente rara',
    category: 'trono_helado', subcategory: 'monturas',
    price_crystals: 2500, quality: 'epic',
    icon: 'ability_mount_spectraltiger', badge: 'TCG',
    features: ['Montura terrestre 310%', 'Rareza TCG original', 'Diseño espectral único'],
    wow_item_ids: [49284],
    action_type: 'send_items',
  }),

  P({
    id: 'riendas_onyxia',
    name: 'Riendas de Onyxia',
    subtitle: 'El dragón de la Señora del Vacío',
    category: 'trono_helado', subcategory: 'monturas',
    price_crystals: 2000, quality: 'epic',
    icon: 'ability_mount_drake_proto', badge: null,
    features: ['Drake épico de vuelo', 'Aspecto icónico de Onyxia', '280% de velocidad'],
    wow_item_ids: [49801 /* v */],
    action_type: 'send_items',
  }),

  P({
    id: 'protodrake_azul',
    name: 'Protodrake Azul',
    subtitle: 'Drake salvaje de las Cumbres Tormentosas',
    category: 'trono_helado', subcategory: 'monturas',
    price_crystals: 1500, quality: 'epic',
    icon: 'ability_mount_drake_blue', badge: null,
    features: ['Drake de vuelo épico', 'Velocidad 280%', 'Aspecto prehistórico único'],
    wow_item_ids: [44151 /* v */],
    action_type: 'send_items',
  }),

  P({
    id: 'nube_trueno',
    name: 'Nube de la Tormenta',
    subtitle: 'Montura de nube única del servidor',
    category: 'trono_helado', subcategory: 'monturas',
    price_crystals: 2000, quality: 'epic',
    icon: 'ability_mount_cloudmount', badge: null,
    features: ['Montura de vuelo épica', 'Velocidad 280%', 'Aspecto místico único'],
    wow_item_ids: [46110 /* v */],
    action_type: 'send_items',
  }),

  // ══════════════════════════════════════════════════════════════════════════
  // TRONO HELADO — MASCOTAS
  // ══════════════════════════════════════════════════════════════════════════

  P({
    id: 'cachorro_tigre',
    name: 'Cachorro de Tigre Espectral',
    subtitle: 'Mascota a juego con la montura',
    category: 'trono_helado', subcategory: 'mascotas',
    price_crystals: 800, quality: 'rare',
    icon: 'ability_mount_spectraltiger_swift', badge: null,
    features: ['Mascota de compañía', 'Diseño espectral', 'Combina con el Tigre Espectral'],
    wow_item_ids: [32588],
    action_type: 'send_items',
  }),

  P({
    id: 'oso_aniversario',
    name: 'Oso de Aniversario Blizzard',
    subtitle: 'Mascota exclusiva del 4º aniversario',
    category: 'trono_helado', subcategory: 'mascotas',
    price_crystals: 500, quality: 'rare',
    icon: 'inv_misc_bearcub_01', badge: null,
    features: ['Oso bebé adorable', 'Exclusiva conmemorativa', 'Pequeño compañero fiel'],
    wow_item_ids: [40408 /* v */],
    action_type: 'send_items',
  }),

  P({
    id: 'cachorro_pandaren',
    name: 'Cachorro Pandaren',
    subtitle: 'El compañero más entrañable de Azeroth',
    category: 'trono_helado', subcategory: 'mascotas',
    price_crystals: 800, quality: 'epic',
    icon: 'achievement_dungeon_naxxramas25man', badge: 'RARO',
    features: ['Mascota legendaria', 'Aspecto Pandaren adorable', 'Muy buscada en el juego'],
    wow_item_ids: [23083 /* v */],
    action_type: 'send_items',
  }),

  P({
    id: 'cachorro_core_hound',
    name: 'Cachorro de Sabueso del Núcleo',
    subtitle: 'La mascota del veterano de Molten Core',
    category: 'trono_helado', subcategory: 'mascotas',
    price_crystals: 600, quality: 'rare',
    icon: 'ability_hunter_pet_corehound', badge: null,
    features: ['Sabueso de fuego en miniatura', 'Aspecto clásico de WoW', 'Raro y coleccionable'],
    wow_item_ids: [49912 /* v */],
    action_type: 'send_items',
  }),

  // ══════════════════════════════════════════════════════════════════════════
  // TRONO HELADO — CONSUMIBLES
  // ══════════════════════════════════════════════════════════════════════════

  P({
    id: 'pack_frascos_caster',
    name: 'Pack: Frasco del Wyrm de Escarcha ×20',
    subtitle: 'El mejor frasco para lanzadores de hechizos',
    category: 'trono_helado', subcategory: 'consumibles',
    price_crystals: 200, quality: 'uncommon',
    icon: 'inv_alchemy_elixir_06', badge: null,
    features: ['+125 Poder de Hechizo durante 1h', 'Persiste al morir', 'x20 unidades'],
    wow_item_ids: Array(20).fill(46376),
    action_type: 'send_items',
  }),

  P({
    id: 'pack_frascos_fisico',
    name: 'Pack: Frasco de Ira Infinita ×20',
    subtitle: 'El mejor frasco para DPS físico',
    category: 'trono_helado', subcategory: 'consumibles',
    price_crystals: 200, quality: 'uncommon',
    icon: 'inv_alchemy_elixir_04', badge: null,
    features: ['+180 Fuerza de ataque durante 1h', 'Persiste al morir', 'x20 unidades'],
    wow_item_ids: Array(20).fill(46377),
    action_type: 'send_items',
  }),

  P({
    id: 'pack_frascos_healer',
    name: 'Pack: Frasco de la Mente Pura ×20',
    subtitle: 'El mejor frasco para sanadores',
    category: 'trono_helado', subcategory: 'consumibles',
    price_crystals: 200, quality: 'uncommon',
    icon: 'inv_alchemy_elixir_05', badge: null,
    features: ['+45 Maná por 5s durante 1h', 'Persiste al morir', 'x20 unidades'],
    wow_item_ids: Array(20).fill(46378),
    action_type: 'send_items',
  }),

  P({
    id: 'pack_frascos_tanque',
    name: 'Pack: Frasco de Sangrolita ×20',
    subtitle: 'El mejor frasco para tanques',
    category: 'trono_helado', subcategory: 'consumibles',
    price_crystals: 200, quality: 'uncommon',
    icon: 'inv_alchemy_elixir_07', badge: null,
    features: ['+650 Salud durante 1h', 'Persiste al morir', 'x20 unidades'],
    wow_item_ids: Array(20).fill(46379),
    action_type: 'send_items',
  }),

  P({
    id: 'pack_pociones_velocidad',
    name: 'Pack: Poción de Velocidad ×20',
    subtitle: 'Explosión de velocidad de ataque',
    category: 'trono_helado', subcategory: 'consumibles',
    price_crystals: 100, quality: 'uncommon',
    icon: 'inv_potion_107', badge: null,
    features: ['+500 Velocidad de ataque 15s', 'Usable en combate', 'x20 unidades'],
    wow_item_ids: Array(20).fill(40211),
    action_type: 'send_items',
  }),

  P({
    id: 'pack_pociones_magia',
    name: 'Pack: Poción de Magia Salvaje ×20',
    subtitle: 'Explosión de poder mágico',
    category: 'trono_helado', subcategory: 'consumibles',
    price_crystals: 100, quality: 'uncommon',
    icon: 'inv_potion_108', badge: null,
    features: ['+200 Poder de hechizo 15s', 'Usable en combate', 'x20 unidades'],
    wow_item_ids: Array(20).fill(40212),
    action_type: 'send_items',
  }),

  // ══════════════════════════════════════════════════════════════════════════
  // TRONO HELADO — APARIENCIAS (Transmog)
  // ══════════════════════════════════════════════════════════════════════════

  P({
    id: 'tabard_lightbringer',
    name: 'Tabardo del Portador de Luz',
    subtitle: 'El tabardo más icónico del Paladín',
    category: 'trono_helado', subcategory: 'apariencias',
    price_crystals: 500, quality: 'epic',
    icon: 'inv_shirt_guildtabard_01', badge: 'EXCLUSIVO',
    features: ['Aspecto de Paladín icónico', 'Compatible con Transmog', 'Entrega directa por correo'],
    wow_item_ids: [31404 /* v */],
    action_type: 'send_items',
  }),

  P({
    id: 'tabard_shattered_sun',
    name: 'Tabardo del Sol Destrozado',
    subtitle: 'El emblema de la Ofensiva del Sol Destrozado',
    category: 'trono_helado', subcategory: 'apariencias',
    price_crystals: 300, quality: 'rare',
    icon: 'inv_shirt_guildtabard_02', badge: null,
    features: ['Diseño clásico de la era TBC', 'Compatible con Transmog', 'Entrega por correo'],
    wow_item_ids: [33602 /* v */],
    action_type: 'send_items',
  }),

  P({
    id: 'tabard_argent_crusade',
    name: 'Tabardo de la Cruzada Argenta',
    subtitle: 'Símbolo de la lucha contra el Rey Exánime',
    category: 'trono_helado', subcategory: 'apariencias',
    price_crystals: 200, quality: 'uncommon',
    icon: 'inv_shirt_guildtabard_03', badge: null,
    features: ['Diseño plateado y dorado', 'Compatible con Transmog', 'Entrega por correo'],
    wow_item_ids: [40643 /* v */],
    action_type: 'send_items',
  }),
];
